export enum VARIANTS {
  PRIMARY = 'PRIMARY',
  PRIMARY_DARK = 'PRIMARY_DARK',
  PRIMARY_LIGHT = 'PRIMARY_LIGHT',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  /** Add more variants here as needed... */
}
